import styled, { css } from 'styled-components';
import { Icon } from '../icon/index.js';
import {} from './index.js';
import { getMargins, SYS_SIZE_FIXED_700, SYS_SIZE_FIXED_900, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_50, getTypographyStyles, SEM_TYPOGRAPHY_UI_SM_LABEL, SYS_BORDER_WIDTH_100, SYS_BORDER_RADIUS_SM, CMP_SIZE_UI_TAG_CLICKABLE_UNDERLINE_THICKNESS, CMP_SPACE_UI_TAG_CLICKABLE_UNDERLINE_OFFSET, SEM_TYPOGRAPHY_UI_XS_LABEL, SYS_SIZE_FIXED_100 } from '@oneaudi/unified-web-alpha-common';
export const StyledLabel = styled.label `
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  color: ${(props) => props.theme.sem.color.ui.foreground.icons.default};
`;
export const StyledText = styled.span ``;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;
export const StyledTagButton = styled.button `
  margin: ${(props) => getMargins(props.margin)};
  border-radius: ${SYS_BORDER_RADIUS_SM};
  border: none;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};
  ${(props) => props.size === 'md'
    ? getTypographyStyles(SEM_TYPOGRAPHY_UI_SM_LABEL)
    : getTypographyStyles(SEM_TYPOGRAPHY_UI_XS_LABEL)};
  padding: ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_150};
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: background-color, box-shadow, color;
  min-height: ${(props) => props.size === 'md' ? SYS_SIZE_FIXED_900 : SYS_SIZE_FIXED_700};

  ${StyledText} {
    text-decoration: underline;
    text-decoration-thickness: ${CMP_SIZE_UI_TAG_CLICKABLE_UNDERLINE_THICKNESS};
    text-underline-offset: ${CMP_SPACE_UI_TAG_CLICKABLE_UNDERLINE_OFFSET};
  }

  ${(props) => !props.disabled &&
    css `
      cursor: pointer;
      background-color: ${props.theme.cmp.color.ui.tag.unselected.surface.fill
        .default};
      box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.ui.tag.unselected.surface.stroke.default};

      ${StyledIcon} {
        // TODO: missing token
        transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
        transition-duration: 250ms;
        transition-property: color;
        color: ${props.theme.cmp.color.ui.tag.unselected.icon.default};
      }

      ${StyledText} {
        color: ${props.theme.cmp.color.ui.tag.unselected.text.default};
      }

      &:hover,
      &:active {
        box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
          ${props.theme.cmp.color.ui.tag.unselected.surface.stroke.interactive};
        background-color: ${props.theme.cmp.color.ui.tag.unselected.surface.fill
        .interactive};

        ${StyledIcon} {
          color: ${props.theme.cmp.color.ui.tag.unselected.icon.interactive};
        }

        ${StyledText} {
          color: ${props.theme.cmp.color.ui.tag.unselected.text.interactive};
        }
      }
    `};

  ${(props) => props.disabled &&
    css `
      cursor: not-allowed;
      background-color: ${props.theme.cmp.color.ui.tag.unselected.surface.fill
        .disabled};
      box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.ui.tag.unselected.surface.stroke.disabled};

      ${StyledIcon} {
        color: ${props.theme.cmp.color.ui.tag.unselected.icon.disabled};
      }

      ${StyledText} {
        color: ${props.theme.cmp.color.ui.tag.unselected.text.disabled};
      }
    `}
`;
export const StyledContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  border-radius: ${SYS_BORDER_RADIUS_SM};
  box-sizing: border-box;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  ${(props) => props.size === 'md'
    ? getTypographyStyles(SEM_TYPOGRAPHY_UI_SM_LABEL)
    : getTypographyStyles(SEM_TYPOGRAPHY_UI_XS_LABEL)};
  ${(props) => props.variant === 'removable'
    ? css `
          padding: ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_100}
            ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_150};
          gap: ${SYS_SPACE_FIXED_50};
        `
    : css `
          padding: ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_150};
          gap: ${SYS_SPACE_FIXED_100};
        `}
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: background-color, box-shadow, color;
  min-height: ${(props) => props.size === 'md' ? SYS_SIZE_FIXED_900 : SYS_SIZE_FIXED_700};

  ${(props) => ['read-only', 'offer', 'removable'].includes(props.variant) &&
    css `
      background-color: ${props.theme.cmp.color.ui.tag.readOnly.surface.fill
        .default};
      box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.ui.tag.readOnly.surface.stroke.default};

      ${StyledIcon} {
        color: ${props.theme.cmp.color.ui.tag.readOnly.icon.default};
      }

      ${StyledText} {
        color: ${props.theme.cmp.color.ui.tag.readOnly.text.default};
      }
    `}

  ${(props) => props.variant === 'encourage' &&
    css `
      background-color: ${props.theme.cmp.color.ui.tag.unselected.surface.fill
        .encourage};
      box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.ui.tag.unselected.surface.stroke.encourage};

      ${StyledIcon} {
        color: ${props.theme.cmp.color.ui.tag.unselected.icon.encourage};
      }

      ${StyledText} {
        color: ${props.theme.cmp.color.ui.tag.unselected.text.encourage};
      }
    `}

  ${(props) => props.variant === 'selectable' &&
    !props.$disabled &&
    css `
      cursor: pointer;
      background-color: ${props.theme.cmp.color.ui.tag.unselected.surface.fill
        .default};
      box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.ui.tag.unselected.surface.stroke.default};

      ${StyledText} {
        color: ${props.theme.cmp.color.ui.tag.unselected.text.default};
      }

      ${StyledIcon} {
        // TODO: missing token
        transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
        transition-duration: 250ms;
        transition-property: color;
        color: ${props.theme.cmp.color.ui.tag.unselected.icon.default};
      }

      &:hover,
      &:active {
        box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
          ${props.theme.cmp.color.ui.tag.unselected.surface.stroke.interactive};
        background-color: ${props.theme.cmp.color.ui.tag.unselected.surface.fill
        .interactive};

        ${StyledText} {
          color: ${props.theme.cmp.color.ui.tag.unselected.text.interactive};
        }

        ${StyledIcon} {
          color: ${props.theme.cmp.color.ui.tag.unselected.icon.interactive};
        }
      }

      &:has(${StyledInput}:checked) {
        background-color: ${props.theme.cmp.color.ui.tag.selected.surface.fill
        .default};
        box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
          ${props.theme.cmp.color.ui.tag.selected.surface.stroke.default};

        ${StyledIcon} {
          color: ${props.theme.cmp.color.ui.tag.selected.icon.default};
        }

        ${StyledText} {
          color: ${props.theme.cmp.color.ui.tag.selected.text.default};
        }
      }

      &:has(${StyledInput}:checked:hover) {
        background-color: ${props.theme.cmp.color.ui.tag.selected.surface.fill
        .interactive};
        box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
          ${props.theme.cmp.color.ui.tag.selected.surface.stroke.interactive};

        ${StyledIcon} {
          color: ${props.theme.cmp.color.ui.tag.selected.icon.interactive};
        }

        ${StyledText} {
          color: ${props.theme.cmp.color.ui.tag.selected.text.interactive};
        }
      }

      &:has(${StyledInput}:focus-visible) {
        outline: auto;
      }
    `};

  ${(props) => props.variant === 'selectable' &&
    props.$disabled &&
    css `
      cursor: not-allowed;
      background-color: ${props.theme.cmp.color.ui.tag.unselected.surface.fill
        .disabled};
      box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.ui.tag.unselected.surface.stroke.disabled};

      ${StyledIcon} {
        color: ${props.theme.cmp.color.ui.tag.unselected.icon.disabled};
      }

      ${StyledText} {
        color: ${props.theme.cmp.color.ui.tag.unselected.text.disabled};
      }

      &:has(${StyledInput}:checked) {
        background-color: ${props.theme.cmp.color.ui.tag.selected.surface.fill
        .disabled};
        box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
          ${props.theme.cmp.color.ui.tag.selected.surface.stroke.disabled};

        ${StyledIcon} {
          color: ${props.theme.cmp.color.ui.tag.selected.icon.disabled};
        }

        ${StyledText} {
          color: ${props.theme.cmp.color.ui.tag.selected.text.disabled};
        }
      }
    `}
`;
export const StyledOuterContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${(props) => props.size === 'md' ? SYS_SIZE_FIXED_100 : SYS_SPACE_FIXED_50};
`;
//# sourceMappingURL=index.styles.js.map